import { render, staticRenderFns } from "./Died.vue?vue&type=template&id=3ea1b78a&scoped=true&"
import script from "./Died.vue?vue&type=script&lang=js&"
export * from "./Died.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea1b78a",
  null
  
)

export default component.exports